import { useState } from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Trans, useTranslation } from 'react-i18next'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { Button, Form, InputGroup } from 'react-bootstrap'
import { Alerts, storeRefs } from 'utils'
import ConfirmModal from 'components/ConfirmModal'
import { IconCheck } from 'components/form'
import { resendOrder } from 'state/Orders'

//<Trans> is only really needed for the printer, but i18next.t() seems to run before the language is selected, and thus doesn't translate the other strings... As <Trans> works... ¯\_(ツ)_/¯
const options = {
	customer: ['user', <Trans>Customer</Trans>],
	email   : ['envelope', <Trans>Email</Trans>],
	sms     : ['sms', <Trans>SMS</Trans>],
	phone   : ['phone-alt', <Trans>Phone call</Trans>],
	tablet  : ['tablet-alt', <Trans>Manager app</Trans>],
	printer : ['print', <Trans>Printer <i>(Order Monitor)</i></Trans>],
	fax     : ['fax', <Trans>Fax</Trans>],
}
const initial = ['customer']

export default function ResendModal({ show, doClose }) {
	const { t }              = useTranslation()
	const { id }             = useParams()
	const dispatch           = useDispatch()
	const channelsState      = useState(initial)
	const [, storage, value] = storeRefs()

	async function doSubmit() {
		await dispatch(resendOrder(id, channelsState[0], value('msg')))
		doClose()
		Alerts.success('The order has been resent.')
	}

	return <ConfirmModal {...{ show, doClose, doSubmit }}
	                     confirmTexts={[t('Send'), t('Sending')]}
	                     confirmIcon="paper-plane"
	                     title={t('Resend to...')}>
		<Form>
			<Form.Group>
				<IconCheck.Group statePair={channelsState} {...{ options, initial }}/>
			</Form.Group>

			<Form.Group controlId="msg">
				<Form.Label>{t('Include a message?')}</Form.Label>
				<InputGroup>
					{/* TODO this might need translation down the road, but right now for CMO it can be kept in English */}
					<Form.Control required ref={storage} defaultValue="Resending per request"/>
					<InputGroup.Append>
						<Button variant="outline-dark" onClick={() => value('msg', '')} title={t('Remove message')}>
							<Icon icon="eraser"/>
						</Button>
					</InputGroup.Append>
				</InputGroup>
				<Form.Text className="text-muted">{t('Included at the top of prints and faxes.')}</Form.Text>
			</Form.Group>
		</Form>
	</ConfirmModal>
}

ResendModal.propTypes = {
	show   : PropTypes.bool.isRequired,
	doClose: PropTypes.func.isRequired,
}
